import React, { useEffect, useState } from "react";
import { InnerNav } from "../components/InnerNav";
import { Overline } from "../components/motion";
import { WorkCard } from "../components/tvui";
import { useTranslate } from "../context/TranslateContext";
import { SERIES } from "../mock/tv";

const TABS = ["All", "Running", "Concluded"];
const LANGS = ["All", "Hindi", "Malayalam", "Tamil", "Telugu"];

export default function TVSerials() {
  const { t } = useTranslate();
  const [tab, setTab] = useState("All");
  const [lang, setLang] = useState("All");
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const serials = SERIES.filter((s) => ["Daily Serial", "Crime Drama", "Drama"].includes(s.category) || s.format === "Series");
  const filtered = serials.filter((s) => (tab === "All" || s.status === tab) && (lang === "All" || s.language === lang));
  const listenText = "TV Serials. Running daily serials, weekly dramas, crime and historical series across Indian languages — with episode guides and catch-up links.";

  return (
    <div className="min-h-screen bg-gradient-to-b from-paper to-surface">
      <InnerNav />
      <div className="mx-auto max-w-[1400px] px-6 py-14 md:px-12 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Overline>TV Serials</Overline>
            <h1 className="mt-3 font-display text-5xl font-semibold tracking-tight text-cream md:text-7xl">{t("Daily ")}<span className="italic text-gradient-gold">{t("Serials")}</span>{t(" & Dramas")}</h1>
            <p className="mt-4 font-body text-lg text-ash">{t("Follow long-running serials episode by episode — no seasons required — plus concluded classics and regional favourites.")}</p>
          </div>
          
        </div>

        <div className="mt-10 flex flex-wrap items-center gap-6">
          <div className="flex gap-2" data-testid="serial-status-tabs">
            {TABS.map((x) => (
              <button key={x} onClick={() => setTab(x)} data-testid={`serial-tab-${x}`}
                className={`rounded-full border px-5 py-2 font-body text-sm transition-colors ${tab === x ? "border-gold bg-gold text-ink" : "border-edge text-cream hover:border-gold"}`}>{t(x)}</button>
            ))}
          </div>
          <div className="flex gap-2">
            {LANGS.map((x) => (
              <button key={x} onClick={() => setLang(x)} data-testid={`serial-lang-${x}`}
                className={`rounded-full px-3 py-1.5 font-body text-sm transition-colors ${lang === x ? "text-gold" : "text-ash hover:text-cream"}`}>{t(x)}</button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5" data-testid="serials-grid">
          {filtered.map((s, i) => <WorkCard key={s.slug} s={s} i={i} />)}
        </div>
        {filtered.length === 0 && <p className="py-16 text-center font-body text-ash" data-testid="serials-empty">{t("No serials match these filters.")}</p>}
      </div>
    </div>
  );
}
